module.exports = __webpack_public_path__ + "static/media/blog2.c1b744d3.jpg";